// App connectivity + sync state: online status, the "syncing" banner flag, and
// whether the Apollo queue link is open. Transitions live in
// connectivity.controller.ts; see CLAUDE.md "Client state ... store".
import { createStore } from './create-store';

const [useOnlineStatus, getOnlineValue, setIsOnline] = createStore(true);
export { useOnlineStatus, getOnlineValue, setIsOnline };

const [useSyncing, getSyncingValue, setIsSyncing] = createStore(false);
export { useSyncing, getSyncingValue, setIsSyncing };

const [useQueueOpen, getQueueOpenValue, setIsQueueOpen] = createStore(true);
export { useQueueOpen, getQueueOpenValue, setIsQueueOpen };

// True once the offline hydrator's replay and score sync have finished since the queue last opened.
const [useOfflineSyncSettled, , setOfflineSyncSettled] = createStore(false);
export { useOfflineSyncSettled, setOfflineSyncSettled };
